'use client';

import React, { useMemo } from 'react';
import { GateOptions } from '@gate-js/react';
import { useJobParams } from './useJobParams';

export default function GateWrapper({ children, options }) {
	const { refId, sourceId, referrer } = useJobParams();

	const memoizedOptions = useMemo(() => ({
		refId,
		origin: sourceId || referrer,
		...options,
	}), [refId, sourceId, options, referrer]);

	return (
		<GateOptions options={memoizedOptions}>
			{children}
		</GateOptions>
	);
}
